import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as storyActions from '../actions/search.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { SearchService } from '../../services';

@Injectable()
export class SearchEffects {
  private actions$ = inject(Actions);
  private searchService = inject(SearchService);


  GetSearchResults$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(storyActions.GetSearchResults),
      switchMap(({ q }) =>
        this.searchService.search(q).pipe(
          map(results => storyActions.GetSearchResultsSuccess({ results })),
          catchError(error => of(storyActions.GetSearchResultsFail({ error })))
        )
      )
    );
  });

  GetMagazineSearchResults$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(storyActions.GetMagazineSearchResults),
      switchMap(({ q }) =>
        this.searchService.SearchMagazine(q).pipe(
          map(results => storyActions.GetMagazineSearchResultsSuccess({ results })),
          catchError(error => of(storyActions.GetMagazineSearchResultsFail({ error })))
        )
      )
    );
  });
}
